import {IScriptLoaderService} from "./script-loader.service.interface";
import {ServiceBase} from "../ServiceBase";
import {LoadScriptOptions} from "../../../common/interfaces/load-script-options";

export class ScriptLoaderService extends ServiceBase implements IScriptLoaderService {
    async loadScript(options: LoadScriptOptions): Promise<void> {
        await this.services.sdk.scriptLoader.loadScript(options);
    }

}